<template>
  <table class="w-full border-separate border-spacing-0 border-none">
    <slot />
  </table>
</template>
